/**
 * In-app Help links (BR-268). The public help site lives outside the product: its base URL and the support address are
 * build-time configuration (public values), and a page is chosen by the user's language (English or French; the other
 * languages show English).
 */
export type HelpTopic = "setup" | "permissions" | "notifications" | "faq" | "retention";

/** The help pages are served by the public side of the app itself (`/help/<language>/<topic>`); a separate help site can still be configured. */
const BASE = (import.meta.env.VITE_HELP_BASE_URL as string | undefined) || "/help";
export const SUPPORT_EMAIL = (import.meta.env.VITE_SUPPORT_EMAIL as string | undefined) ?? "";

export function helpUrl(topic: HelpTopic, locale: string): string | null {
  if (!BASE) return null;
  const two = locale.toLowerCase().slice(0, 2);
  const lang = two === "fr" || two === "de" || two === "es" ? two : "en";
  return `${BASE.replace(/\/$/, "")}/${lang}/${topic}`;
}

export function supportMailto(subject: string): string | null {
  return SUPPORT_EMAIL ? `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}` : null;
}
